import React from 'react';
import PropTypes from 'prop-types';

import { Table, TableRow, TableCell } from '../../components';
import { config } from '../../api/config';
import {
  formatActivityRecordChanges,
  formatActivityRecordDate,
  formatActivityRecordTarget,
  formatActivityRecordType,
  getActivityRecordId,
  getActivityRecordStorageKey,
} from './admins.helpers';
import styles from './admins.module.scss';

const PAGE_SIZE = 10;

const AdminRecords = ({
  admin,
  records,
  loading,
  total,
  page,
  onPageChange,
}) => {
  const tableHeader = ['Data ir laikas', 'Tipas', 'Tikslas', 'Pokyčiai'];

  const renderRecords = () =>
    records.map((record, index) => {
      const type = formatActivityRecordType(record);
      const target = formatActivityRecordTarget(record);
      const recordId = getActivityRecordId(record);
      const key =
        recordId || `${formatActivityRecordDate(record)}-${type}-${index}`;
      const recordUrl =
        recordId && admin && admin.id
          ? config.APP_PATHS.adminRecord(admin.id, recordId)
          : null;

      const handleRecordClick = () => {
        if (
          !recordId ||
          !admin ||
          !admin.id ||
          typeof sessionStorage === 'undefined'
        ) {
          return;
        }

        try {
          sessionStorage.setItem(
            getActivityRecordStorageKey(admin.id, recordId),
            JSON.stringify({ admin, record })
          );
        } catch (e) {
          // Ignore storage failures and continue with route state.
        }
      };

      return (
        <TableRow
          key={key}
          url={recordUrl}
          state={recordUrl ? { admin, record } : undefined}
          onClick={handleRecordClick}
        >
          <TableCell>{formatActivityRecordDate(record)}</TableCell>
          <TableCell>{type}</TableCell>
          <TableCell>{target}</TableCell>
          <TableCell>{formatActivityRecordChanges(record)}</TableCell>
        </TableRow>
      );
    });

  return (
    <section className={styles.records}>
      <h4 className={styles.recordsLabel}>Įrašai</h4>
      <Table
        header={tableHeader}
        isEmpty={!records.length}
        loading={loading}
        page={page}
        pageSize={PAGE_SIZE}
        total={total}
        serverPagination={true}
        width="lg"
        onPageChange={onPageChange}
      >
        {renderRecords()}
      </Table>
    </section>
  );
};

AdminRecords.propTypes = {
  admin: PropTypes.object.isRequired,
  records: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  total: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default AdminRecords;
